<template>
	<div @click="phonechick" id="app">
		<keep-alive :exclude="cached">
		      <router-view :key="$route.fullPath"></router-view>
		</keep-alive>
		<div class="keepUrlCss">
			<a href="https://www.1yunhui.com" target="_blank" style="margin-left: 200px;color: #909399;">Copyright 2023 北京壹云汇科技有限公司 版权所有</a>
		</div>
	</div>
</template>
<script>
	// import warnModal from './views/wran/index.vue'
	import Cookies from "js-cookie";
	import vueBus from '@/commons/vueBus';
	export default {
		name:'App',
		components: {
			// warnModal
		},
		data() {
			return {
				visibles: false,
				datas: [],
				cached: this.$store.state.catchArr,
			}
		},
		// watch: {
		// 	$route(to, from) {
		// 		this.cached = this.$store.state.catchArr;
		// 	}
		// },
		mounted() {
			//     this.visibles=true
			//       window.setInterval(() => {
			//   setTimeout(() => {
			//     try {
			//       this.$http.get("/alarm/alarmUnconfirmed").then((res) => {
			//         if (res.code == 200) {
			//             this.datas=res.data
			//             console.log(this.datas,"jjjkk")
			//             res.data.forEach(item=>{
			//                 console.log(item.id)
			//                 let alarmId=[]
			//                 let a=alarmId.push(item.id)
			//                 console.log(a,"alarmId")
			//                 // if(item){
			//                 //     console.log(this.visibles,"jj")
			//                 //     //   this.visibles=true
			//                 //        console.log(this.visibles,"jj")
			//                 // }
			//                 //    this.visibles=true
			//             })
			//         //   res.data.map((item) => {
			//         //     this.alarmObj = item;
			//         //   });
			//         //   this.$forceUpdate();
			//         //    this.visibles=true
			//         }
			//       });
			//     } catch (e) {
			//       this.$message.error(e.message || "操作失败");
			//     }
			//   }, 0);
			// }, 10000);
		},
		methods: {
			// 动态更改账号名字
			phonechick() {
				if (Cookies.get('userNames') == undefined || sessionStorage.getItem("userNames") == null) {
					return false
				}
				if (sessionStorage.getItem("userNames") != Cookies.get('userNames')) {
					sessionStorage.setItem("userNames", Cookies.get('userNames'))
					vueBus.$emit("bload", Cookies.get('userNames'));
				}
			}
			// getMsgFormSon(data){
			//   this.visibles=data
			// }
		},
	}
</script>
<style>
	html,
	body,
	#app {
		width: 100%;
		height: 97%;
		font-size: 14px;
		box-shadow: none;
		text-shadow: none;
		/* background: antiquewhite; */
		box-sizing: border-box;
		font-family: Avenir, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC,
			Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial,
			sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
	}
	.keepUrlCss{
		width: 100%;
		text-align: center;
		font-size: 14px;
	}
	/* .lim_float_icon{
		display: none;
	} */
</style>
